var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hr",style:({
    borderBottomWidth: _vm.size + 'px',
    borderBottomColor: _vm.color,
    borderBottomStyle: 'solid',
    margin: _vm.margin,
    width: _vm.width
  })})}
var staticRenderFns = []

export { render, staticRenderFns }